import type {CssBaselineProps as MaterialCssBaselineProps} from '@mui/material/CssBaseline';
import MaterialCssBaseline from '@mui/material/CssBaseline';
import {FC} from 'react';

export type CssBaselineProps = MaterialCssBaselineProps;

export const CssBaseline: FC<CssBaselineProps> = (props) => (
    <MaterialCssBaseline {...props}/>
);
